import { createSelector } from "@reduxjs/toolkit";
import { openapi } from "../../../../../openapi";
import { IRootState } from "../../../../store";

export const makeSelectRelatedChecklistDkStats = (reviewId: string) =>
  createSelector(
    [(state: IRootState) => openapi.endpoints.getChecklistsByReviewByReviewId.select({ reviewId })(state).data ?? []],
    (checklists) => {
      const dkApprovedCount = checklists.filter((checklist) => {
        const approvedAt = checklist.doksam?.dkApproval?.approvedAt;
        return approvedAt != null && String(approvedAt).trim().length > 0;
      }).length;

      return {
        totalCount: checklists.length,
        dkApprovedCount,
      };
    },
  );
